module.exports = __webpack_public_path__ + "img/kg.3f3c0a0c.svg";